<template>
    <layout-internal-container>
        <div class="w-full flex flex-col gap-8">
            <div class="flex flex-col gap-4 md:flex-row justify-between md:items-center">
                <div class="flex flex-col gap-4">
                    <span class="text-sm text-light font-medium">See your webinar schedule from all your joined
                        program</span>
                    <div class="flex flex-row gap-2 items-center">
                        <!-- <span v-for="item in statusOption"
                            :class="item === statusActive ? 'bg-primary text-white' : 'bg-white border text-light'"
                            class="rounded-full px-3 py-1 items-center h-fit flex text-xs cursor-pointer"
                            @click="statusActive = item" :key="item">{{ item }}</span> -->
                        <a-date-picker v-model:value="filterDate" format="MMM-YYYY" picker="month" @change="fetchWebinar()" :allowClear="false"/>
                    </div>
                </div>
                <div @click="$router.push('/Internal/Calendar')"
                    class="text-primary flex flex-row justify-center cursor-pointer text-sm items-center gap-2 w-fit">
                    <span class="font-medium">Go To Calendar</span>
                    <IconArrowRight :size="18" />
                </div>
            </div>
            <div class="flex flex-col gap-6" v-if="isProgressFinished">
                <div v-for="(webinar, index) in webinars" :key="index"
                    v-if="webinars.length > 0"
                    class="flex flex-col md:flex-row border px-4 py-8"
                >
                    <div
                        class="flex flex-col md:flex-row md:items-center md:justify-between flex-grow md:gap-8 md:pl-6 pr-0">
                        <div class="space-y-2">
                            <span class="text-sm font-medium">{{ webinar.title }}</span>
                            <div class="flex flex-wrap gap-4 items-center text-sm text-gray-500">
                                <div class="flex items-center gap-2" v-if="webinar?.program">
                                    <img :src="webinar.program.photo" class="h-6 w-6 rounded-md object-cover"
                                        alt="">
                                    <span>{{ webinar.program.title }}</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconClockHour3Filled class="text-gray-300" :size="20"
                                        stroke-width="1.8" />
                                    <span>{{ webinar.time_start }} - {{ webinar.time_end }}</span>
                                </div>
                                <!-- <div v-if="webinar.status === 'Ongoing'"
                                    class="flex items-center gap-2 text-primary">
                                    <div class="h-2 w-2 bg-primary rounded-full"></div>
                                    <span class="font-medium">Live Now</span>
                                </div> -->
                                <div v-if="
                                    isBetweenDateTime(webinar.date, webinar.time_start, webinar.time_end)
                                    "
                                    class="flex items-center gap-2 text-primary">
                                    <div class="h-2 w-2 bg-primary rounded-full"></div>
                                    <span class="font-medium">Live Now</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex md:justify-end mt-8 md:mt-0 md:ml-auto">
                            <!-- <div v-if="isBetweenDateTime(webinar.date, webinar.time_start, webinar.time_end)">
                                <a-button @click="openWebinar" type="primary">Join Now</a-button>
                            </div>
                            <div v-if="isBeforeDateTime(webinar.date, webinar.time_start, webinar.time_end)">
                                <a-button @click="$router.push('/Internal/Calendar?action=webinar')">Set
                                    Reminder</a-button>
                            </div> -->
                            
                            <a-button @click="openWebinar(webinar.link_room)" type="primary">Join Now</a-button>
                        </div>
                    </div>
                </div>
                <div class="w-full gap-2 flex flex-col items-center justify-center mt-8" v-else>
                    <p>There isn't webinar yet.</p>
                    <p>Please join the program and wait for further details.</p>
                </div>
            </div>
        </div>
    </layout-internal-container>
</template>

  
<script setup>
import { onMounted, ref } from 'vue'
import { IconArrowRight, IconClockHour3Filled } from '@tabler/icons-vue'
import DummyProgram from '@/assets/Dummy/program.js'
import { openWebinar } from "@/plugins/constant.ts"
import moment from 'moment';
import axios from '@/plugins/axios';
import dayjs from 'dayjs';

const statusOption = ref(['All', 'Upcoming', 'Pending', 'Past', 'Cancelled'])
const statusActive = ref('All')

const webinars = ref([])
const filterDate = ref(dayjs())
const isProgressFinished = ref(false)

const fetchWebinar = async () => {
    try {
        const response = await axios.get('/webinar', {
            params: {
                month: filterDate.value.month() + 1,
                year: filterDate.value.year()
            }
        });
        
        webinars.value = response?.data?.data
    } catch (error) {
        console.error('Error fetching webinar:', error)
    }finally{
        isProgressFinished.value = true
    }
}


const isBetweenDateTime = (date, timeStart, timeEnd) => {
    return moment().isBetween(
        moment(`${date} ${timeStart}`, 'YYYY-MM-DD hh:mm A'), 
        moment(`${date} ${timeEnd}`, 'YYYY-MM-DD hh:mm A')
    )
};

onMounted(() => {
    fetchWebinar();
});

</script>
